import React from 'react';
import { Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './authentication.scss';
import brandLogo from '../../assets/images/logo.png';

const AuthLayout = ({ children, title, subtitle, showBrand = true, wide = false }) => {
  return (
    <div className="auth-page">
      <div className={`auth-container ${wide ? 'auth-wide' : ''}`}>
        <Card className="auth-card">
          <div className="auth-header text-center mb-4">
            {showBrand && (
            <Link to="/" className="brand-logo text-primary d-flex align-items-center justify-content-center gap-2 text-decoration-none mb-2">
              <img src={brandLogo} alt="Logo" className="img-fluid" style={{ height: "40px" }} />
            </Link>
            )}
            {title && <div className="title text-lg text-gray-900 fw-bold">{title}</div>}
            {subtitle && <div className="subtitle text-sm text-gray-500">{subtitle}</div>}
          </div>
          {children}
        </Card>
      </div>
    </div>
  );
};

export default AuthLayout;
